module.exports = __webpack_public_path__ + "img/full1-min.b0053f69.png";